/** Default student meal-plan terms shown when no version body is saved yet. */
export const DEFAULT_MEAL_PLAN_TC_BODY = `Student meal plan terms

1. Cancellation
You may cancel individual booked meals for the following week until Saturday 11:59 pm New Zealand time. After that cutoff, bookings lock and cannot be changed by you.

2. No-shows
Booked meals that are not collected are not refunded and do not automatically carry over to another week.

3. Exceptions / carryovers
Requests to move unused meals to another week are not guaranteed. They require manager approval and may be declined.

4. Repeat requests
Frequent exception requests may be flagged for review. Managers keep final discretion.

5. Payment
Subscribing charges the plan price for the target week. Completing payment activates your subscription and (for auto-book plans) creates next-week bookings.

By accepting, you confirm you have read and agree to these terms for this version.`;

export function resolveMealPlanTcBody(stored: string | null | undefined): string {
  const trimmed = String(stored || '').trim();
  return trimmed || DEFAULT_MEAL_PLAN_TC_BODY;
}
